module.exports = __webpack_public_path__ + "img/JP.73895ac3.png";